import { render, staticRenderFns } from "./SupaBaseHeaderSec.vue?vue&type=template&id=2942b1bf&scoped=true&"
import script from "./SupaBaseHeaderSec.vue?vue&type=script&lang=js&"
export * from "./SupaBaseHeaderSec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2942b1bf",
  null
  
)

export default component.exports